'use client';

import React__default, { memo } from 'react';

var CurveLine = function (_a) {
    var _b = _a.color, color = _b === void 0 ? '#000' : _b, className = _a.className;
    return (React__default.createElement("svg", { className: className, width: 18, height: 6, viewBox: '0 0 18 6', fill: 'none', xmlns: 'http://www.w3.org/2000/svg' },
        React__default.createElement("path", { d: 'M1.3 3.992v0C2.363 1.393 5.634.56 7.81 2.334l1.077.877a4.946 4.946 0 0 0 2.168 1.019v0A4.944 4.944 0 0 0 15.8 2.555l.648-.773', stroke: color, strokeWidth: 2, strokeLinecap: 'round' })));
};
var CurveLine$1 = memo(CurveLine);

export { CurveLine$1 as default };
//# sourceMappingURL=CurveLine.js.map
